// utils/rum.ts — RUM ringan: FCP/LCP/CLS per pageview publik → analytics_events.
// Sampling 20% agar tidak membanjiri tabel. Baris ditandai eventData.rum=true
// (gabung di event page_view, kategori form) — filter rum=true utk laporan speed.
const SAMPLE_RATE = 0.2;

function collect(): Promise<{ fcp?: number; lcp?: number; cls?: number }> {
    return new Promise((resolve) => {
        const out: { fcp?: number; lcp?: number; cls?: number } = {};
        let cls = 0;
        try {
            const po = new PerformanceObserver((list) => {
                for (const e of list.getEntries()) {
                    if (e.entryType === 'paint' && e.name === 'first-contentful-paint') {
                        out.fcp = Math.round(e.startTime);
                    }
                    if (e.entryType === 'largest-contentful-paint') {
                        out.lcp = Math.round((e as PerformanceEntry & { startTime: number }).startTime);
                    }
                    if (e.entryType === 'layout-shift') {
                        const s = e as PerformanceEntry & { hadRecentInput?: boolean; value?: number };
                        if (!s.hadRecentInput) cls += s.value ?? 0;
                    }
                }
            });
            po.observe({ type: 'paint', buffered: true });
            po.observe({ type: 'largest-contentful-paint', buffered: true });
            po.observe({ type: 'layout-shift', buffered: true });
            // LCP stabil ~6 dtk setelah load → kirim sekali.
            setTimeout(() => {
                po.disconnect();
                out.cls = Math.round(cls * 1000) / 1000;
                resolve(out);
            }, 6000);
        } catch {
            resolve(out);
        }
    });
}

export function initRum(): void {
    try {
        if (Math.random() > SAMPLE_RATE) return;
        void collect().then((v) => {
            if (v.fcp === undefined && v.lcp === undefined) return;
            void import('./trackingPixels/track').then(({ trackAnalyticsEvent }) =>
                trackAnalyticsEvent('page_view', 'form', null, {
                    eventData: { rum: true, fcp: v.fcp, lcp: v.lcp, cls: v.cls },
                }),
            );
        });
    } catch {
        /* no-op */
    }
}
